import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobApplications: [],
  pagination: {}
};

const jobApplicationsSlice = createSlice({
  name: 'jobApplications',
  initialState,
  reducers: {
    jobApplicationsDetails(state, action) {
      return {
        ...state,
        ...action.payload,
        isDeleted: false,
        isUpdated: false,
        isAdded: false
      };
    },
    updateJobApplications(state, action) {
      const jobApplicationId = action.payload.id;
      const jobApplications = state.jobApplications.map((applyJob) => {
        if (applyJob.AppliedJobs.ID === jobApplicationId) {
          return {
            ...applyJob,
            AppliedJobs: { ...applyJob.AppliedJobs, Status: action.payload.Status }
          };
        }
        return applyJob;
      });
      return { ...state, jobApplications };
    }
  }
});

export const { jobApplicationsDetails, updateJobApplications } = jobApplicationsSlice.actions;
export default jobApplicationsSlice.reducer;
